import React, {useEffect, useState} from "react";
import '../../../css/web/AdminTaxListModal.css';
import commonClose from '../../../assets/img/commonClose.png'
import {useNavigate} from "react-router-dom";

function AdminTaxListModal({
                               pt1DataShow,
                               pt1Data,
                               closePt1DataPopup,
                               completeFilter,
                               fedexUnMatchShow,
                               fedexUnMatchList,
                               closeFedexUnMatchShow,
                               upsUnMatchShow,
                               upsUnMatchList,
                               closeUpsUnMatchShow
                           }) {


    const [checkedItems, setCheckedItems] = useState(new Set());
    const isAllChecked = pt1Data && pt1Data.length > 0 && checkedItems.size === pt1Data.length;

    useEffect(() => {
        if (pt1Data && pt1Data.length > 0) {
            const allItemIds = new Set(pt1Data.map(item => item.seqNum));
            setCheckedItems(allItemIds);
        }
    }, [pt1Data]);

    const handleSelectAll = (e) => {
        const { checked } = e.target;
        if (checked) {
            const allItemIds = new Set(pt1Data.map(item => item.seqNum));
            setCheckedItems(allItemIds);
        } else {
            setCheckedItems(new Set());
        }
    };

    const handleSelectItem = (seqNum) => {
        const newCheckedItems = new Set(checkedItems);
        if (newCheckedItems.has(seqNum)) {
            newCheckedItems.delete(seqNum);
        } else {
            newCheckedItems.add(seqNum);
        }
        setCheckedItems(newCheckedItems);
    };

    const handleCompleteFilter = () => {
        const filteredData = pt1Data.filter(item => checkedItems.has(item.seqNum));
        completeFilter(filteredData);
    };

    const convertToShipco = ((dvType, defalutShipco) => {
        if (dvType === 'D00') {
            return '국내배송';
        } else if (dvType === 'D01') {
            return 'FedEx';
        } else if (dvType === 'D16') {
            return 'FedEx-E';
        } else if (dvType === 'D11') {
            return 'UPS';
        } else if (dvType === 'D17') {
            return 'UPS-E';
        } else if (dvType === 'D02') {
            return 'EMS';
        } else if (dvType === 'D15') {
            return 'EMSP';
        } else if (dvType === 'D04') {
            return 'DHL';
        } else if (dvType === 'D13') {
            return 'K-Packet';
        } else if (dvType === 'D14') {
            return 'Small-Packet';
        } else if (dvType === 'D03') {
            return 'SEA';
        } else {
            return defalutShipco;
        }
    });



    return (
        <div className="modal-overlay">

            { pt1DataShow ?
                // pt1Data (기존과 동일)
                <div className="modal-content">
                    <div className="modal-header">
                        <h3>세무 데이터 필터링</h3>
                        <img className="close-icon" src={commonClose} alt="close" onClick={closePt1DataPopup}/>
                    </div>

                    <div className="modal-body">
                        <div className="table-container">
                            <table className="tax-table">
                                <thead>
                                <tr>
                                    <th style={{width: '5%'}}>
                                        <input
                                            type="checkbox"
                                            checked={isAllChecked}
                                            onChange={handleSelectAll}
                                        />
                                    </th>
                                    <th style={{width: '5%'}}></th>
                                    <th style={{width: '25%'}}>박스번호</th>
                                    <th style={{width: '15%'}}>성함</th>
                                    <th style={{width: '15%'}}>배송사</th>
                                    <th style={{width: '15%'}}>총배송료</th>
                                    <th style={{width: '20%'}}>운송장번호</th>
                                </tr>
                                </thead>
                                <tbody>
                                {pt1Data && pt1Data.map((item, index) => (
                                    <tr key={item.seqNum || index}>
                                        <td>
                                            <input
                                                type="checkbox"
                                                checked={checkedItems.has(item.seqNum)}
                                                onChange={() => handleSelectItem(item.seqNum)}
                                            />
                                        </td>
                                        <td>{index + 1}</td>
                                        <td>{item.orderdtDTO.orderNumber + "-" + item.shipInfoDTO.boxNum}</td>
                                        <td>{item.orderdtDTO.regNm}</td>
                                        <td>{convertToShipco(item.dvType)}</td>
                                        <td>{item.ttShipExpense?.toLocaleString()}원</td>
                                        <td>{item.shipInfoDTO.outWayNum}</td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className="modal-footer">
                        <button className="filter-complete-btn" onClick={handleCompleteFilter}>
                            필터완료 ({checkedItems.size}개 선택됨)
                        </button>
                    </div>
                </div>

                :

                fedexUnMatchShow ?
                    // FedEx 데이터 (이전 답변과 동일)
                    <div className="modal-content">
                        <div className="modal-header">
                            <h3>FedEx 매칭불가 리스트</h3>
                            <img className="close-icon" src={commonClose} alt="close" onClick={closeFedexUnMatchShow}/>
                        </div>

                        <div className="modal-body">
                            <div className="table-container">
                                <table className="tax-table">
                                    <thead>
                                    <tr>
                                        <th style={{width: '5%'}}></th>
                                        <th style={{width: '22%'}}>박스번호</th>
                                        <th style={{width: '12%'}}>성함</th>
                                        <th style={{width: '10%'}}>배송사</th>
                                        <th style={{width: '12%'}}>청구액(예상)</th>
                                        <th style={{width: '12%'}}>청구액(실제)</th>
                                        <th style={{width: '12%'}}>차액금</th>
                                        <th style={{width: '15%'}}>운송장번호</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {fedexUnMatchList && fedexUnMatchList.map((item, index) => (
                                        <tr key={item.waybill || index}>
                                            <td>{index + 1}</td>
                                            <td className="c-point">
                                                {item.isDbEntry ? (
                                                    <a style={{color: "#4B89DC"}}
                                                       href={`/btcorpad/orderdtmodi/${item.orderNumber}`}
                                                       target="_blank" rel="noopener noreferrer">
                                                        {item.boxNum}
                                                    </a>
                                                ) : (
                                                    <span>{item.orderNumber}</span>
                                                )}
                                            </td>
                                            <td>{item.name}</td>
                                            <td>{item.shipCo}</td>
                                            <td>{item.expectedPrice.toLocaleString()} 원</td>
                                            <td>{item.actualPrice.toLocaleString()} 원</td>
                                            <td style={{color: "#E05E6D"}}>{item.diff.toLocaleString()} 원</td>
                                            <td>{item.waybill}</td>
                                        </tr>
                                    ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div className="modal-footer">
                            {/* [수정] fedexUnMatchList.length로 변경 */}
                            <button className="filter-complete-btn" onClick={closeFedexUnMatchShow}>
                                데이터 총({fedexUnMatchList.length}개)
                            </button>
                        </div>
                    </div>

                    :

                    upsUnMatchShow ?
                        // [수정] UPS 데이터
                        <div className="modal-content">
                            <div className="modal-header">
                                <h3>UPS 매칭불가 리스트</h3>
                                <img className="close-icon" src={commonClose} alt="close"
                                     onClick={closeUpsUnMatchShow}/>
                            </div>

                            <div className="modal-body">
                                <div className="table-container">
                                    <table className="tax-table">
                                        <thead>
                                        <tr>
                                            <th style={{width: '5%'}}></th>
                                            <th style={{width: '22%'}}>박스번호</th>
                                            <th style={{width: '12%'}}>성함</th>
                                            <th style={{width: '10%'}}>배송사</th>
                                            <th style={{width: '12%'}}>청구액(예상)</th>
                                            <th style={{width: '12%'}}>청구액(실제)</th>
                                            <th style={{width: '12%'}}>차액금</th>
                                            <th style={{width: '15%'}}>운송장번호</th>
                                        </tr>
                                        </thead>
                                        {/* [수정] <tbody> 렌더링 로직 변경 */}
                                        <tbody>
                                        {upsUnMatchList && upsUnMatchList.map((item, index) => (
                                            <tr key={item.waybill || index}>
                                                <td>{index + 1}</td>
                                                <td className="c-point">
                                                    {item.isDbEntry ? (
                                                        <a style={{color: "#4B89DC"}}
                                                           href={`/btcorpad/orderdtmodi/${item.orderNumber}`}
                                                           target="_blank" rel="noopener noreferrer">
                                                            {item.boxNum}
                                                        </a>
                                                    ) : (
                                                        <span>{item.orderNumber}</span>
                                                    )}
                                                </td>
                                                <td>{item.name}</td>
                                                <td>{item.shipCo}</td>
                                                <td>{item.expectedPrice.toLocaleString()} 원</td>
                                                <td>{item.actualPrice.toLocaleString()} 원</td>
                                                <td style={{color: "#E05E6D"}}>{item.diff.toLocaleString()} 원</td>
                                                <td>{item.waybill}</td>
                                            </tr>
                                        ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <div className="modal-footer">
                                {/* [수정] upsUnMatchList.length로 변경 */}
                                <button className="filter-complete-btn" onClick={closeUpsUnMatchShow}>
                                    데이터 총({upsUnMatchList.length}개)
                                </button>
                            </div>
                        </div>
                        :
                        null
            }

        </div>
    )
}

export default AdminTaxListModal
